import { theme } from '@app/theme';

export const exitAssessmentStatuses = {
    1: { key: 'pending', name: 'Pending', sx: theme.companyStatus.onboarding, dotColor: '#C3C7D0' },
    2: { key: 'inProgress', name: 'In Progress', sx: theme.companyStatus.inProgress },
    3: { key: 'complete', name: 'Complete', sx: theme.companyStatus.completed },
};
